import Enum from "../../enum";
import {
    DATA_TYPE,
    COMMUNICATION_FORMAT,
    DATA_FORMAT,
    DOMAIN_MAX_LENGTH,
} from "../constants";

export const userSchema = {
    "user": {
        "id": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "authId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.AUTH_ID,
            value: "",
        },
        "password": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.PASSWORD,
            value: "",
        },
        "role": {
            type: DATA_TYPE.ENUM,
            enum: "UserRole",
            value: Enum.BE_USER_ROLE.USER,
        },
        "createdDate": {
            type: DATA_TYPE.DATE,
            value: null,
            format: DATA_FORMAT.YYYYMMDD_HHmm,
            communication: COMMUNICATION_FORMAT.TIME,
        },
        "updatedDate": {
            type: DATA_TYPE.DATE,
            value: null,
            format: DATA_FORMAT.YYYYMMDD_HHmm,
            communication: COMMUNICATION_FORMAT.TIME,
        }
    },

    "userToken": {
        "id": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "accessToken": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.TOKEN,
            value: "",
        },
        "refreshToken": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.TOKEN,
            value: "",
        },
        "accessTokenExpirationTime": {
            type: DATA_TYPE.NUMBER,
            value: 0,
        },
        "refreshTokenExpirationTime": {
            type: DATA_TYPE.NUMBER,
            value: 0,
        },
        "createdDate": {
            type: DATA_TYPE.DATE,
            value: null,
            format: DATA_FORMAT.YYYYMMDD_HHmm,
            communication: COMMUNICATION_FORMAT.TIME,
        },
        "updatedDate": {
            type: DATA_TYPE.DATE,
            value: null,
            format: DATA_FORMAT.YYYYMMDD_HHmm,
            communication: COMMUNICATION_FORMAT.TIME,
        },
        "userId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        }
    },

    "expansionToken": {
        "id": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "accessToken": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.TOKEN,
            value: "",
        },
        "refreshToken": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.TOKEN,
            value: "",
        },
        "tokenExpirationTime": {
            type: DATA_TYPE.NUMBER,
            value: 0,
        },
    }
} as const;
